import { h } from 'preact';
import { useUser } from '../../hooks/user';
import FormError from './FormError';

const TextInput = ({
	label,
	placeholder = '',
	name,
	type = 'text',
	maxLength = null,
}: {
	label: string,
	name: string,
	placeholder?: string,
	type?: string,
	maxLength?: number,
}) => {
	const {
		user, dispatch, dispatchTouch, errors, touched,
	} = useUser();

	return (
		<div>
			<label
				className={[
					'ea-label',
					touched.includes(name) && errors[name] !== undefined ? 'error' : '',
				].join(' ')}
				htmlFor={name}
			>
				{label}
			</label>
			<input
				className={[
					'ea-input',
					touched.includes(name) && errors[name] !== undefined ? 'error' : '',
				].join(' ')}
				type={type}
				id={name}
				name={name}
				maxLength={maxLength}
				placeholder={placeholder}
				onChange={(e) => {
					dispatch({
						type: 'UPDATE_USER',
						payload: {
							[name]: e.currentTarget.value,
						},
					});
				}}
				onBlur={() => {
					dispatchTouch({
						type: 'TOUCH_FIELD',
						payload: name,
					});
				}}
				// @ts-ignore
				value={user[name] ?? ''}
			/>
			{touched.includes(name) && errors[name] !== undefined
				? (<FormError error={errors[name]} />) : null}
		</div>
	);
};

export default TextInput;
